exports.composeEventHandlers=function(e,n,{checkForDefaultPrevented:t=!0}={}){return function(r){if(null==e||e(r),!1===t||!r.defaultPrevented)return null==n?void 0:n(r)}};
//# sourceMappingURL=index.js.map
